import { config } from "../config";
import { STRINGS } from "../constants/strings";

export function LegalFooter() {
  return (
    <footer class="tl-footer">
      <a
        href={config.legals.privacy}
        target="_blank"
        rel="noopener noreferrer"
      >
        {STRINGS.footerPrivacy}
      </a>
      {" | "}
      <a
        href={config.legals.imprint}
        target="_blank"
        rel="noopener noreferrer"
      >
        {STRINGS.footerImprint}
      </a>
      {" | "}
      <a
        href={config.legals.reportContent}
        target="_blank"
        rel="noopener noreferrer"
      >
        {STRINGS.footerReportContent}
      </a>
    </footer>
  );
}
